// Auto generated file, do not manually modify!
// com.hotpads.listingdatamodeltypes.enums.listingcostandfee.FeeTypeGrouping

export enum FeeTypeGrouping {
  ACCOUNTING = 'ACCOUNTING',
  ADD_ON = 'ADD_ON',
  ADMIN = 'ADMIN',
  AMENITIES = 'AMENITIES',
  APPLICATION = 'APPLICATION',
  CLEAN = 'CLEAN',
  CUSTOM = 'CUSTOM',
  DAMAGE = 'DAMAGE',
  GOVT = 'GOVT',
  HOLD = 'HOLD',
  INSURANCE = 'INSURANCE',
  KEY = 'KEY',
  LEASE = 'LEASE',
  LEGAL = 'LEGAL',
  OTHER = 'OTHER',
  PARKING = 'PARKING',
  PENALTY = 'PENALTY',
  PETS = 'PETS',
  SECURITY_DEPOSIT = 'SECURITY_DEPOSIT',
  SERVICE = 'SERVICE',
  STORAGE = 'STORAGE',
  TECHNOLOGY = 'TECHNOLOGY',
  TERM = 'TERM',
  TRANSFER = 'TRANSFER',
  UPGRADE = 'UPGRADE',
  UTILITIES = 'UTILITIES',
  VIOLATION = 'VIOLATION',
}

export const FeeTypeGrouping_values = [
  FeeTypeGrouping.ACCOUNTING,
  FeeTypeGrouping.ADD_ON,
  FeeTypeGrouping.ADMIN,
  FeeTypeGrouping.AMENITIES,
  FeeTypeGrouping.APPLICATION,
  FeeTypeGrouping.CLEAN,
  FeeTypeGrouping.CUSTOM,
  FeeTypeGrouping.DAMAGE,
  FeeTypeGrouping.GOVT,
  FeeTypeGrouping.HOLD,
  FeeTypeGrouping.INSURANCE,
  FeeTypeGrouping.KEY,
  FeeTypeGrouping.LEASE,
  FeeTypeGrouping.LEGAL,
  FeeTypeGrouping.OTHER,
  FeeTypeGrouping.PARKING,
  FeeTypeGrouping.PENALTY,
  FeeTypeGrouping.PETS,
  FeeTypeGrouping.SECURITY_DEPOSIT,
  FeeTypeGrouping.SERVICE,
  FeeTypeGrouping.STORAGE,
  FeeTypeGrouping.TECHNOLOGY,
  FeeTypeGrouping.TERM,
  FeeTypeGrouping.TRANSFER,
  FeeTypeGrouping.UPGRADE,
  FeeTypeGrouping.UTILITIES,
  FeeTypeGrouping.VIOLATION,
] as const;
